export default __webpack_public_path__ + "static/media/IG.3528826f.svg";